<template>
  <b-modal
    contentClass="md-confirm-content"
    :hideHeader= "true"
    dialog-class="modal-dialog2"
    bodyClass= "confirm-body"
    footerClass= "confirm-footer"
    :okTitle= "$t('common.ok')"
    :cancelTitle= "$t('common.cancel1')"
    okVariant= "primary md_btn_primary"
    cancelVariant= "secondary md_btn_light"
    centered
    :visible="visible"
    @hidden="onCancel"
    @ok="onOk"
  >
    <div class="wrapper">
      <div class="titleLabel" style="margin-top: 15px">{{$t('more.withdraw_title')}}</div>
      <div class="contentLabel" style="margin-top: 20px" v-html="$t('more.withdraw_confirm')"/>
      <b-input v-model="phone"
               :formatter="Utils.formatPhoneNumber"
               :placeholder="$t('more.withdraw_phone')"
               class="input input_wrapper"
               style="margin-bottom: 0"
      />
    </div>


  </b-modal>
</template>

<script>
import Utils from "../../../config/utils";

export default {
  name: "ConfirmExitPopup",
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      Utils:Utils,
      phone:''
    }
  },
  methods:{
    onOk(e){
      e.preventDefault();
      Utils.requestPost(
        this.$c.API.User.exitApp,
        {
          phone: this.phone.replaceAll('-','')
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.myinfo.accessToken = '';
          this.$perf.setString(this.$c.PREF_PARAMS.PHONE, '');
          this.$perf.setString(this.$c.PREF_PARAMS.CODE, '');
          let self = this;
          setTimeout(()=>{
            Utils.toast(self, self.$t('more.on_withdrawed'));
          },500);

          this.$router.push('login');
          this.$emit('update:visible', false);


        } else {
          Utils.toast(this,result.msg);
        }
      });
    },
    onCancel(){
      this.$emit('update:visible', false);
    }
  },
}
</script>

<style lang="scss" scoped>
 @import "../../../assets/css/_vars.scss";

 .wrapper{
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
 }
 .titleLabel{font-size: $fs_24; color: $black; text-align: center; font-family: $korean_gd_15_r};
 .contentLabel{
   font-size: $fs_22;
   color: #cf0000;
   text-align: center;
   font-family: $korean_gd_15_r;
   text-decoration: underline;
 };
 .input_wrapper{
   height: 50px;
   width: 350px;
   border-width: 1px;
   border-color: #bebdbd;
   border-radius: 0;
   padding:0;
   margin:22px 33px;
   justify-content:center
 };
 .input{
   color: $black;
   font-size: $fs_22;
   font-family: $korean_gd_14_r;
   text-align: center;
   padding:0;
 }
 ::placeholder{
   color: $c_a6a6a6;
 }
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/ConfirmExitPopup.vue